import axios from "axios";

// Development: empty string → relative URLs go through the dev proxy (setupProxy.js)
// Production: full backend URL from env or fallback
export const API_BASE =
  process.env.NODE_ENV === "development"
    ? ""
    : process.env.REACT_APP_API_BASE || "https://prageethperera-001-site1.etempurl.com";
const ordersUrl = `${API_BASE}/api/orders`;

export default class MailService {
  postToEndPoint(data) {
    return new Promise((resolve) => {
      axios
        .post(ordersUrl, data)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => {
          resolve(error);
        });
    });
  }
}
